// Custom confirmation dialog with loading state
import React, { useState, useEffect } from "react";
import { FiAlertTriangle } from "react-icons/fi";
import "../styles/ConfirmDialog.css";

export default function ConfirmDialog({
  title = "Are you sure?",
  message,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  variant = "danger",
  onConfirm,
  onCancel,
}) {
  const [loading, setLoading] = useState(false);

  // Lock body scroll while dialog is open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="confirm-overlay" onClick={loading ? undefined : onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className={`confirm-icon-wrap confirm-${variant}`}>
          <FiAlertTriangle size={20} />
        </div>
        <h3 className="confirm-title">{title}</h3>
        {message && <p className="confirm-message">{message}</p>}
        <div className="confirm-actions">
          <button
            className="confirm-btn-cancel"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            className={`confirm-btn-action confirm-btn-${variant}`}
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? <span className="spinner-sm" /> : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
